/* DEVELOPER NOTE:

  Find and replace this string, '// DevComment: ' with '' if you want get some
  sweets debug messages. But you have to revert the changes for two reasons:
  1. We want to keep those lines in order to debug again.
  2. No production enviroment should have console o other test committed to
     production.

  Also, help us improve our debugging code. Thanks
*/
!function(global) {
  'use strict';

  var previousBreadCrumb = global.BreadCrumb;

  function BreadCrumb(options) {
    var options = options || {};
    var $container;
    var sourceTpl;
    var hbTpl;
    
    function init() {
      $container = options.$container;
      sourceTpl = $(options.hbtpl).html();
      hbTpl = Handlebars.compile(sourceTpl);
    }

    function update(data) {
      var context = {};
      var html;

      $container.empty();
      context.breadcrumbs = data;
      html = hbTpl(context);

      //TODO: Fragments
      $container.append(html);
    }

    init();

    return {
      update: update
    }

  }

  BreadCrumb.noConflict = function noConflict() {
    global.BreadCrumb = previousBreadCrumb;
    return BreadCrumb;
  };

  global.BreadCrumb = BreadCrumb;

}(this);